import { ICellRendererParams } from 'ag-grid-community'
import styled from 'styled-components'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { colorPalette } from '../../../../style/colorPalette'
import { FontWeight } from '../../../../../styles/commonStyles'
import { useMemo } from 'react'

export const ProgressRateDiffCellRenderer = (
  params: ICellRendererParams<ProgressReportTableContent>
) => {
  const value = params.data?.progressRateDiff

  const numericValue = useMemo<number | undefined>(
    () =>
      typeof value === 'string' ? parseFloat(value.replace('%', '')) : value,
    [value]
  )

  return <StyledCell numericValue={numericValue}>{value}</StyledCell>
}

const HIGHLIGHT_THRESHOLDS = {
  CRITICAL: -50,
  WARNING: -20,
} as const

const StyledCell = styled('div')<{ numericValue?: number }>(({
  numericValue,
}) => {
  let backgroundColor = 'transparent'

  if (
    numericValue !== undefined &&
    numericValue !== null &&
    !isNaN(numericValue)
  ) {
    if (numericValue < HIGHLIGHT_THRESHOLDS.CRITICAL) {
      backgroundColor = colorPalette.pink[1]
    } else if (
      numericValue >= HIGHLIGHT_THRESHOLDS.CRITICAL &&
      numericValue < HIGHLIGHT_THRESHOLDS.WARNING
    ) {
      backgroundColor = colorPalette.yellow[1]
    }
  }

  return {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor,
    fontWeight: FontWeight.BOLD,
    overflow: 'hidden',
    padding: '0 6px',
  }
})
